import { connect } from 'react-redux'
import {
  makeSelectGroupById,
  selectOpenGroupIds,
} from 'ducks/folders/selectors/groups'
import { doToggleGroup } from 'ducks/folders/operations/groups'
import GroupView from './view'

const select = () => {
  const selectGroupById = makeSelectGroupById()

  return (state, props) => {
    const { id, name, icon, folderIds } = selectGroupById(state, props)
    const openGroupIds = selectOpenGroupIds(state)
    return {
      name,
      open: openGroupIds.includes(id),
      icon,
      folderIds,
    }
  }
}

const perform = {
  onClick: id => doToggleGroup({ groupId: id }),
}

export default connect(select, perform)(GroupView)
